import React from "react";
import service from "../../assets/img/inner-banner/Services.webp";
import "./ServicesPageComponent.css";
import { Container } from "react-bootstrap";
const ServiceBanner = () => {
  return (
    <>
      <section>
        <Container fluid className="bannersection position-relative p-0">
          <img
            src={service}
            alt="Service banner"
            className="w-100 h-100 object-fit-cover about-banner-img"
          />
          <div className="textoverlay d-flex flex-column justify-content-center align-items-center position-absolute top-0 w-100 h-100 text-center">
            {/* <h1 className="heading">Diamond's Preliminary Examination</h1> */}
          </div>
        </Container>
      </section>
    </>
  );
};

export default ServiceBanner;
